module.exports = __webpack_public_path__ + "static/media/team.ff4bbb07.svg";